import '@/styles/theme.css';

import { initDataDogRUM } from '@picsart/datadog-rum';
import type { IPicsartToolPubSub } from '@picsart/miniapps-sdk/types';
import { createRoot } from 'react-dom/client';

import { datadogConfiguration } from '@/consts/datadog';

import App from './components/App';
import setupContext from './miniappContext';
import Wrappers from './Wrappers';

const setup = ({ containerId, pubsub }: { containerId: string; pubsub?: IPicsartToolPubSub }) => {
  initDataDogRUM(datadogConfiguration);
  const container = document.getElementById(containerId)!;
  const root = createRoot(container);
  setupContext({ pubsub });
  root.render(
    <Wrappers>
      <App />
    </Wrappers>,
  );

  return {
    unmount: () => root.unmount(),
  };
};

export default setup;
